import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import theme from 'shared/styles/theme';

const PdfViewerScreen = () => {
  const { pdfUrl } = useLocalSearchParams<{ pdfUrl: string }>();

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          title: '',
          headerBackVisible: true,
          headerShown: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} />
          ),
        }}
      />
      <PdfViewer url={pdfUrl} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    height: '100%',
  },
});

export default PdfViewerScreen;
